import Model from '@ember-data/model';
import attr from 'ember-data/attr';
import { hasMany } from 'ember-data/relationships';
import CampaignModel from './campaign';
import ImportModel from './import';
import ExportModel from './export';
import SegmentModel from './segment';
import NewsletterModel from './newsletter';

// in some cases, API returns limited embedded user records for display reasons - that can belong to other (non-current) accounts
// examples are imports and exports initialized when masquerading by CIO win account (id=1) users
// it's possible to use main "user" model, but limited API response overwrites other user properties with empty values
export default class UserOtherAccountModel extends Model {
  @attr('string') email!: string;
  @attr('string') firstName!: string;
  @attr('string') lastName!: string;

  @hasMany('segment', { async: false, inverse: 'createdByUser' }) createdSegments!: SegmentModel;
  @hasMany('segment', { async: false, inverse: 'updatedByUser' }) updatedSegments!: SegmentModel;
  @hasMany('campaign', { async: false, inverse: 'createdByUser' }) createdCampaigns!: CampaignModel;
  @hasMany('campaign', { async: false, inverse: 'updatedByUser' }) updatedCampaigns!: CampaignModel;
  @hasMany('newsletter', { async: false, inverse: 'createdByUser' }) createdNewsletters!: NewsletterModel;
  @hasMany('newsletter', { async: false, inverse: 'updatedByUser' }) updatedNewsletters!: NewsletterModel;
  @hasMany('import', { async: false, inverse: 'user' }) imports!: ImportModel;
  @hasMany('export', { async: false, inverse: 'user' }) exports!: ExportModel;
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'user-other-account': UserOtherAccountModel;
  }
}
